/**
 * 数字转换千分位  1000000 =》 1,000,000
 * @export
 * @param {number} num
 * @returns
 */
export default (num) => {
  let str = num + ''
  let arr = str.split('').reverse()
  return arr.reduce((prev, next, index) => {
    return ((index % 3) ? next : (next + ',')) + prev
  })
}



// WEBPACK FOOTER //
// ./src/filters/commafy.js